import { ValidationInfo } from "@skbkontur/react-ui-validations";

import { FiasExtendFieldsType } from "../../../FiasInput/Types/FiasTypes";
import { FiasAddress } from "../../../Utils/FiasAddressUtils";
import { FiasWidgetContainerProps } from "../FiasWidgetContainer";
import { FullFormState } from "../../../../../../Engine/Core/Store/FullFormState";

export const buildValidationInfo = (
    value: FiasAddress,
    props: Pick<FiasWidgetContainerProps, "stringAddress" | "extendedFields" | "viewModelSelect" | "bindingPath">,
    state: FullFormState
): ValidationInfo | null => {
    const errorMessage: string | null = getFirstValidationMessage("error", props, state);
    if (errorMessage) {
        return { level: "error", type: "immediate", message: errorMessage };
    }

    const warningMessage: string | null = getFirstValidationMessage("warning", props, state);
    if (warningMessage) {
        return { level: "warning", type: "immediate", message: warningMessage };
    }

    const guidPath = props.extendedFields.find(it => it.type === FiasExtendFieldsType.guid)?.path ?? "";
    const guid = value[guidPath];
    const foreignAddressPath =
        props.extendedFields.find(it => it.sourceValue.at(0)?.fiasApiPath === "foreignAddress")?.path ?? "";
    const foreignAddress = value[foreignAddressPath];
    const isForeignCountry = !!foreignAddress;
    if (!guid && !isForeignCountry && props.stringAddress) {
        return { level: "warning", type: "immediate", message: "Указан адрес не из справочника" };
    }

    return null;
};

const getFirstValidationMessage = (
    validationType: "error" | "warning",
    props: Pick<FiasWidgetContainerProps, "extendedFields" | "viewModelSelect" | "bindingPath">,
    state: FullFormState
): string | null => {
    for (const extendedField of props.extendedFields) {
        const fieldPath = props.bindingPath.joinWith(...extendedField.path.split("/"));
        const controlModel = props.viewModelSelect.controlModel(state, fieldPath);

        if (controlModel[validationType]) {
            return controlModel[validationType];
        }
    }

    return null;
};
